import styles from './Calculatorresultskey.module.css'

export type CalculatorresultskeyProps = {
  title: string
  subtitle: string
  keys: any
}

export const PhnxCalculatorresultskey: React.FC<CalculatorresultskeyProps> = ({
  keys,
  subtitle,
  title,
}) => {
  return (
    <div className={`container ${styles['calculatorresultskey']}`}>
      <div className={styles['title']}>{title}</div>
      <div className={styles['keycolors']}>
        <div className={styles['keyitem']}>
          <div className={styles['vlow']}></div>
          <div className={styles['keyitemtitle']}>Very low</div>
        </div>
        <div className={styles['keyitem']}>
          <div className={styles['low']}></div>
          <div className={styles['keyitemtitle']}>Low</div>
        </div>
        <div className={styles['keyitem']}>
          <div className={styles['typical']}></div>
          <div className={styles['keyitemtitle']}>Typical</div>
        </div>
        <div className={styles['keyitem']}>
          <div className={styles['high']}></div>
          <div className={styles['keyitemtitle']}>High</div>
        </div>
        <div className={styles['keyitem']}>
          <div className={styles['vhigh']}></div>
          <div className={styles['keyitemtitle']}>Very high</div>
        </div>
        <div className={styles['keyitem']}>
          <div className={styles['business']}>
            <img src="/assets/yourbusiness.png" alt="" width="30px" height="30px"></img>
          </div>
          <div className={styles['keyitemtitle']}>Your business</div>
        </div>
      </div>
      <div className={styles['subtitle']}>{subtitle}</div>
      {keys.map((key: any, index: any) => (
        <div key={index} className={styles['key']}>
          {key}
        </div>
      ))}
    </div>
  )
}
